module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "header-wrap-sticky",
    staticStyle: {
      "background": "#000000",
      "color": "#ffffff",
      "border-bottom": "none"
    },
    attrs: {
      "id": "mainStickyHeader"
    }
  }, [_c('div', {
    staticClass: "row header-wrap-inner",
    staticStyle: {
      "border-bottom": "none",
      "margin": "0"
    }
  }, [_c('li', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [(_vm.set_menu) ? _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "background": "#000000 !important",
      "color": "#ffffff",
      "text-decoration": "none"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "14px"
    }
  }), _c('span', {}, [_vm._v("  "), _c('b', [_vm._v(_vm._s(_vm.header_name))])])]) : _c('a', {
    staticClass: "header-nav-back",
    staticStyle: {
      "background": "#000000 !important",
      "color": "#ffffff"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "color": "#ffffff",
      "font-size": "14px"
    }
  }), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("  "), _c('b', [_vm._v(_vm._s(_vm.header_name))])])])]), _vm._v(" "), _c('li', {
    staticClass: "header-right-2",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('a', {
    staticStyle: {
      "background": "#000000 !important"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    staticStyle: {
      "color": "#ffffff",
      "margin-top": "1em"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pager pager-clear-sticky",
    staticStyle: {
      "background": "#ffffff"
    },
    attrs: {
      "id": "topPanel"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "container"
  }, [(_vm.set_menu) ? _c('div', {
    staticClass: "banner-menu",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "menu-links menu-links-strip"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('profile', 'profile')
      }
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account')
      }
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('orders', 'orders')
      }
    }
  }, [_vm._m(3)])]), _vm._v(" "), (!_vm.loading) ? _c('li', [(_vm.can_multiple_shops) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/businesses')
      }
    }
  }, [_vm._m(4)]) : _c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/business')
      }
    }
  }, [_vm._m(5)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('savedshops', 'savedshops')
      }
    }
  }, [_vm._m(6)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/groups')
      }
    }
  }, [_vm._m(7)])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('settings', 'settings')
      }
    }
  }, [_vm._m(8)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('invite', 'invite')
      }
    }
  }, [_vm._m(9)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('knowledge', 'knowledge')
      }
    }
  }, [_vm._m(10)])])])])]) : _c('div', {
    staticClass: "page-body"
  }, [(this.$route.path != '/account') ? _c('div', [_c('router-view')], 1) : _c('div', {
    staticStyle: {
      "margin-top": "-1em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "page-header",
    staticStyle: {
      "padding": "0 1em",
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn sp-button-02 sp-button-02-lt",
    on: {
      "click": function($event) {
        _vm.setMenuLink('profile', 'profile')
      }
    }
  }, [_vm._v("View Profile")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuComponent('profile', 'profile')
      }
    }
  }, [_vm._m(11), _vm._v(" "), (_vm.user && (Object.keys(_vm.user).length > 0)) ? _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.user.user_name))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "menu-links menu-links-strip"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('profile', 'profile')
      }
    }
  }, [_vm._m(12)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account')
      }
    }
  }, [_vm._m(13)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('orders', 'orders')
      }
    }
  }, [_vm._m(14)])]), _vm._v(" "), (!_vm.loading) ? _c('li', [(_vm.can_multiple_shops) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/businesses')
      }
    }
  }, [_vm._m(15)]) : _c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/business')
      }
    }
  }, [_vm._m(16)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('savedshops', 'savedshops')
      }
    }
  }, [_vm._m(17)])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.routeToPage('/account/groups')
      }
    }
  }, [_vm._m(18)])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('settings', 'settings')
      }
    }
  }, [_vm._m(19)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('invite', 'invite')
      }
    }
  }, [_vm._m(20)])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuLink('knowledge', 'knowledge')
      }
    }
  }, [_vm._m(21)])])])])])])])])]), _vm._v(" "), (_vm.can_show_footer) ? _c('component-footer', {
    staticStyle: {
      "z-index": "5"
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Account Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Stores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Store")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("My Saved Shops")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Market Groups")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Invite a Friend")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Help")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "width": "50",
      "height": "50"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Account Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Orders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Stores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Store")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("My Saved Shops")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Market Groups")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Settings")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Invite a Friend")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ac_subject"
  }, [_c('h4', [_vm._v("Help")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2d28d02"}!./src/pages/Account/Template/template.html
// module id = 591
// module chunks = 0